import apiClient from '@/utils/apiClient';
import { HubspotContact } from '@/interfaces/IHubspotContact';

const CREATE_HUBSPOT_CONTACT = '/api/reseller/hubspot-create-contact';
const GET_HUBSPOT_CONTACT = (email: string) =>
	`/api/reseller/hubspot-get-contact/${encodeURIComponent(email)}`;

export const createHubspotContact = async (formData: HubspotContact) => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: CREATE_HUBSPOT_CONTACT,
		body: formData,
	});

	return response;
};

export const getHubspotContact = async (email: string) => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: GET_HUBSPOT_CONTACT(email),
	});

	return response;
};
